<script setup>
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import {
  mdiClose,
  mdiDotsVertical,
  mdiLogout
} from '@mdi/js'
import NavBarItem from './NavBarItem.vue'
// import NavBarItemLabel from './NavBarItemLabel.vue'
import NavBarMenu from './NavBarMenu.vue'
//import NavBarSearch from './NavBarSearch.vue'
const store = useStore()
const storeVar = computed(() => store.state.Project)
const formVar = reactive({
  oldPassword: null,
  password: null,
  confirmPassword: null,
  passwordModal: false,
  deleteModelStatus:false
})

const isNavBarVisible = computed(() => !store.state.isFullScreen)

const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

const isMenuNavBarActive = ref(false)

const menuNavBarToggleIcon = computed(() => isMenuNavBarActive.value ? mdiClose : mdiDotsVertical)

const menuNavBarToggle = () => {
  isMenuNavBarActive.value = !isMenuNavBarActive.value
}
onBeforeMount(()=>{
  loadData()
})
function loadData() {
  let token =sessionStorage.getItem('accessToken')
  if(token){
    store.dispatch("Project/getUserProfile");
  }else{
    return null
  }
}
// add function
async function changePass() {
  if (oldPasswordValidation.value || passwordValidation.value || confirmPasswordValidation.value) {
      return null
  }
  await store.dispatch('Auth/changePass', {
      oldPassword: formVar.oldPassword,
      password: formVar.password,
      confirmPassword: formVar.confirmPassword
  })
  formVar.passwordModal = false;
}

const logout = () => {
  store.dispatch('Auth/Logout')
  formVar.deleteModelStatus = false
}
 
// validation
const oldPasswordValidation = computed(() => {
  if (!formVar.oldPassword) {
    return 'Required.'
  } else {
    return null
  }
})

const passwordValidation = computed(() => {
  if (!formVar.password) {
    return 'Required.'
  } else {
    return null
  }
})

const confirmPasswordValidation = computed(() => {
  if (!formVar.confirmPassword) {
    return 'Required.'
  } else {
    return null
  }
})
// function deleteModel() {
//   formVar.deleteModelStatus = true
// }
// end of validation
</script>

<template>
  <nav
    v-show="isNavBarVisible"
    class="top-0 left-0 right-0 fixed flex bg-white h-14 border-b border-blue-100 shadow-md shadow-blue-100 dark:shadow-none z-30 w-screen transition-position xl:pl-60 lg:w-auto lg:items-stretch dark:bg-gray-900 dark:border-gray-800"
    :class="{ 'ml-60 lg:ml-0': isAsideMobileExpanded }"
  >
    <div class="flex-1 items-stretch flex h-14">
      <!-- <nav-bar-item type="flex lg:hidden" @click.prevent="menuToggleMobile">
        <base-icon :path="menuToggleMobileIcon" size="24" />
      </nav-bar-item>
      <nav-bar-item type="hidden lg:flex xl:hidden" @click.prevent="menuOpenLg">
        <base-icon :path="mdiMenu" size="24" />
      </nav-bar-item>
      <nav-bar-item>
       
      </nav-bar-item> -->
    </div>
    <div class="flex-none items-stretch flex h-14 lg:hidden">
      <nav-bar-item @click.prevent="menuNavBarToggle">
        <base-icon :path="menuNavBarToggleIcon" size="24" />
      </nav-bar-item>
    </div>
    <div
      class="absolute w-screen top-14 left-0 bg-white shadow lg:w-auto lg:items-stretch lg:flex lg:flex-grow lg:static lg:border-b-0 lg:overflow-visible lg:shadow-none dark:bg-gray-900"
      :class="[isMenuNavBarActive ? 'block' : 'hidden']"
    >
      <div
        class="max-h-screen-menu overflow-y-auto lg:overflow-visible lg:flex lg:items-stretch lg:justify-end lg:ml-auto"
      >
        <nav-bar-menu has-divider>
          <div>
            <span>{{ storeVar.name }}</span>
          </div>

          <template #dropdown>
            <!-- <nav-bar-item @click.prevent="navigate('/profile')">
              <nav-bar-item-label :icon="mdiAccountCircle" label="Profile" />
            </nav-bar-item> -->
            <!-- <nav-bar-item @click.prevent="deleteModel">
              <nav-bar-item-label :icon="mdiLogout" label="Logout" />
            </nav-bar-item> -->
          </template>
        </nav-bar-menu>
        <nav-bar-item is-desktop-icon-only @click.prevent="logout">
          <nav-bar-item-label :icon="mdiLogout" label="Log out" is-desktop-icon-only  />
        </nav-bar-item>
      </div>
    </div>
  </nav>
  <modal-box v-model="formVar.deleteModelStatus" title="Logout">
    <div class="flex justify-center">
      <p class="text-red-600 pb-5">Are you sure you want to Logout ?</p>

    </div>
    <base-buttons class="flex justify-center">
      <base-button @click="logout()" color="danger" small label="Logout" />
    </base-buttons>
  </modal-box>
  <!-- this is change pass model -->
  <modal-box v-model="formVar.passwordModal" title="Change Password" form @submit.prevent="onPassSubmit()">
    <section>
      <div class="grid grid-cols-1 lg:grid-cols-1 gap-6">
          <base-field label="Old Password *" :help="oldPasswordValidation">
            <base-control v-model="formVar.oldPassword" type="password" name="oldPassword" autocomplete="Old Password" />
          </base-field>
          
          <base-field label="Password *" :help="passwordValidation">
            <base-control v-model="formVar.password" type="password" name="password" autocomplete="Password" />
          </base-field>

          <base-field label="Confirm Password *" :help="confirmPasswordValidation">
            <base-control v-model="formVar.confirmPassword" type="password" name="confirmPassword" autocomplete="Confirm Password" />
          </base-field>
      </div>
      <base-buttons type="justify-center lg:justify-center pt-5">
        <base-button 
          type="button"
          color="info"
          small
          label="Submit"
          v-if="!storeVar.loaderNew"
          @click.prevent="changePass"
        />
      </base-buttons>
    </section>
  </modal-box>
</template>